export default "__VITE_ASSET__Dpo1W_Sf__"